module.exports = __webpack_public_path__ + "img/logo_header_lp.213ed115.svg";